/**
 * API 客户端配置
 */

import axios from 'axios';
import { useAuthStore } from '../store/authStore';
import { toast } from 'sonner';

// 创建 axios 实例
const apiClient = axios.create({
  baseURL: (import.meta as any).env.VITE_API_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 处理错误
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 401:
          // 检查是否是登录/注册请求，这些请求的 401 是正常错误，不要跳转
          const isAuthRequest = error.config?.url?.includes('/auth/');
          if (isAuthRequest) {
            // 登录/注册失败，显示具体错误信息
            const message = data?.error?.message || '认证失败';
            toast.error(message);
          } else {
            // Token 过期，登出
            useAuthStore.getState().logout();
            toast.error('登录已过期，请重新登录');
            window.location.href = '/login';
          }
          break;
        
        case 403:
          toast.error('无权访问');
          break;
        
        case 404:
          toast.error('请求的资源不存在');
          break;
        
        case 429:
          toast.error('请求过于频繁，请稍后再试');
          break;
        
        default:
          const message = data?.error?.message || '请求失败';
          toast.error(message);
      }
    } else if (error.request) {
      toast.error('网络错误，请检查连接');
    } else {
      toast.error(error.message || '发生错误');
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
